document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        document.querySelectorAll('.bg-video video').forEach(video => {
            video.playsInline = true;

            video.addEventListener('canplay', () => {
                video.play();
            });

            if (video.readyState >= 3) {
                video.play();
            }
        });
    }, 500);
});